<template>
    <Head title="Ubah Team" />
    <div class="row justify-content-md-center">
        <div class="card col-sm-6">
            <div class="card-header">
                <h3 class="card-title">UBAH TEAM</h3>
                <div class="card-tools">
                    <Link href="/team" class="btn btn-tool"><i class="fas fa-times"></i></Link>
                </div>
            </div>
            <form @submit.prevent="submit">
                <div class="card-body">
                    <input-select2 v-model="form.user_id" :error="form.errors.user_id" label="Penagihan"
                        :options="penagihans" :settings="{
                            placeholder: 'Pilih data ...',
                            allowClear: true,
                        }" disabled>
                    </input-select2>
                    <input-select2 v-model="form.team" :error="form.errors.team" label="Team" :options="kelompoks"
                        :settings="{
                            placeholder: 'Pilih data ...',
                            allowClear: true,
                        }">
                    </input-select2>
                </div>
                <div class="card-footer">
                    <button type="submit" class="btn btn-primary mr-2">Simpan</button>
                </div>
            </form>
        </div>
    </div>
</template>
  
<script>
import Layout from '@/Layouts/Master'
import { Head, Link } from '@inertiajs/vue3'
import InputSelect2 from '@/Forms/InputSelect2'

export default {
    layout: Layout,
    props: {
        team: Object,
        penagihans: Array,
    },
    components: {
        Head,
        Link,
        InputSelect2
    },
    data() {
        return {
            form: this.$inertia.form({
                user_id: this.team.user_id,
                team: this.team.team,
            }),
            id: this.team.id,
            kelompoks: [
                {
                    id: "TEAM A", text: "TEAM A",
                },
                {
                    id: "TEAM B", text: "TEAM B",
                },
                {
                    id: "TEAM C", text: "TEAM C",
                },
                {
                    id: "TEAM D", text: "TEAM D",
                },
                {
                    id: "TEAM E", text: "TEAM E",
                },
                {
                    id: "TEAM F", text: "TEAM F",
                },
                {
                    id: "TEAM G", text: "TEAM G",
                },
            ],
        }
    },
    methods: {
        submit() {
            this.form.patch('/team/' + this.id, {
                preserveScroll: true,
                onSuccess: page => {
                    toastr.success('Ubah Team berhasil', 'SUKSES')
                },
                onError: errors => {
                    toastr.error('Ubah Team gagal', 'GAGAL')
                },
            })
        },
    },
}
</script>